import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { BehaviorSubject } from 'rxjs';
import { List } from '../shared/interfaces/list';

@Injectable({
  providedIn: 'root'
})
export class HomeshoppingDataService {
  public getfilterlist = new BehaviorSubject<any>({});
  public getfilterlistrange = new BehaviorSubject<any>({});
  data: any
  constructor(private dataService: DataService) { }

  getfilterlistLocal() {
    return this.getfilterlist.asObservable();
  }
  getfilterrangelistLocal() {
    return this.getfilterlistrange.asObservable();

  }


  getShoppingMenu() {
    return this.dataService.getRecord('/api/product/getShoppingMenu');
  };
  getHomeShoppingProducts() {
    return this.dataService.getRecord('/api/productDetail/getHomeShoppingProducts');
  };
  getProductTypeList() {
    return this.dataService.getRecord('/api/lookup/getProductTypeList');
  }

  getProductsBySubCategoryId(searchQuery: any) {
    return this.dataService.getRecordWithParams('/api/product/getProductsBySubCategoryId', searchQuery);
  };
  UpdateCart(productDetailId: any) {
    return this.dataService.post('/api/OrderDetail/UpdateCart', productDetailId);
  };

  getOrderDetailByMustHaveAnyOneIds(mustHaveAnyOneIds: any) {
    return this.dataService.post('/api/OrderDetail/getOrderDetailByMustHaveAnyOneIds', mustHaveAnyOneIds);
  };
  GetCart() {
    return this.dataService.getRecord('/api/OrderDetail/GetCart');
  };
  getProductDetailsById(productDetailId: number) {
    return this.dataService.post('/api/product/getProductDetailsById', productDetailId);
  };
  getSelectedShoppingProductsUsingSubCategory(subCategoryId: number) {
    return this.dataService.getRecord('/api/productDetail/getSelectedShoppingProductsUsingSubCategory/' + subCategoryId);
  }
  getSelectedHomeShoppingProducts(productListType: any) {
    return this.dataService.getRecord('/api/productDetail/getSelectedHomeShoppingProducts/' + productListType);
  }











  getShoppingConfigurationByProductId(productId: number) {
    return this.dataService.getRecord('/api/productDetail/getShoppingConfigurationByProductId/' + productId);
  }




  getBreadcrumb(searchQuery) {
    return this.dataService.getRecordWithParams('/api/product/getBreadcrumb', searchQuery);
  };

  saveOrderDetail(orderDetail: any) {
    return this.dataService.post('/api/OrderDetail/saveOrderDetail', orderDetail);
  };
  saveRainTopUp(orderDetail: any) {
    return this.dataService.post('/api/Application/saveRainTopUp', orderDetail);
  };
  getPromotionsForShopping() {
    return this.dataService.getRecord('/api/promotion/getPromotionsForShopping');
  };


  getManageShoppingListWithParams() {
    return this.dataService.getRecord('/api/OrderDetail/getManageShoppingList');
  };
  getManageShoppingList(searchQuery: string) {
    return this.dataService.getRecordWithParams('/api/OrderDetail/getManageShoppingList', searchQuery);
  };
  getManageShoppingOrdersList(searchQuery: string, refresh: boolean) {
    return this.dataService.getDataWithParams('/api/OrderDetail/getManageShoppingList', searchQuery, refresh);
  };
  getShoppingProductIds() {
    return this.dataService.getRecord('/api/OrderDetail/getShoppingProductIds');
  };
  updateOrderDetail(orderDetail: any) {
    return this.dataService.post('/api/OrderDetail/updateOrderDetail', orderDetail);
  };
  approveOrReject(orderDetail: any) {
    return this.dataService.post('/api/OrderDetail/approveOrReject', orderDetail);
  };



  getOrderDetailByStaticIPIds(StaticIPIds: number) {
    return this.dataService.post('/api/OrderDetail/getOrderDetailByStaticIPIds', StaticIPIds);
  };

  getMyOrderList(searchQuery: string) {
    return this.dataService.getRecordWithParams('/api/OrderDetail/getMyOrderList', searchQuery);
  };
  downloadDebitFormPDF(orderDetailId: number) {
    return this.dataService.getRecord('/api/OrderDetail/DownloadDebitFormReport/' + orderDetailId);
  };
  downloadPortingFormPDF(orderDetailId: number) {
    return this.dataService.getRecord('/api/OrderDetail/DownloadPortingDetailFormReport/' + orderDetailId);
  };
  downloadInvoiceFormPDF(orderDetailId: number) {
    return this.dataService.getReport('/api/OrderDetail/DownloadInvoiceReport/' + orderDetailId);
  };
  // getShoppingAddressbyUserId() {
  //   return this.dataService.post('/api/OrderDetail/getShoppingAddressbyUserId', this.data);
  // };

  getShoppingAddressbyUserId() {
    return this.dataService.getRecord('/api/OrderDetail/getShoppingAddressbyUserId');
  };

  saveCreditCardVoucher(promosave: any) {
    return this.dataService.post('/api/OrderDetail/saveCreditCardVoucher', promosave);
  };
  getCreditCardVoucher(params: any) {
    return this.dataService.post('/api/OrderDetail/getCreditCardVoucher', params);
  };
  getShoppingdebitbankdetails(shoppingAddressId: number) {
    return this.dataService.post('/api/OrderDetail/getShoppingdebitbankdetails/' + shoppingAddressId, this.data);
  };
  getdebitFormbankdetails(applicationIdId) {
    return this.dataService.post('/api/OrderDetail/getdebitFormbankdetails/' + applicationIdId, this.data);
  };

  downloadInvoicePDF(orderLineItemId: number) {
    return this.dataService.getReport('/api/OrderDetail/DownloadInvoicePDF/' + orderLineItemId);
  };
  getProductNameById(productIds: Number) {
    return this.dataService.post('/api/product/getProductNameById', productIds);
  };
  getOrderHistory(orderLineItemId: number) {
    return this.dataService.post('/api/OrderDetail/getOrderHistory/' + orderLineItemId, this.data);
  };
  cancelLineItem(orderLineItemId: number, isCompletedShoppingProduct: any) {
    return this.dataService.post('/api/OrderDetail/cancelLineItem/?orderLineItemId=' + orderLineItemId + ' &isCompletedShoppingProduct=' + isCompletedShoppingProduct, this.data);
  };
  sendMailToSalesForEft(orderId: number) {
    return this.dataService.post('/api/OrderDetail/sendMailToSalesForEft/' + orderId, this.data);
  };

  getCourierTracking(searchQuery: string) {
    return this.dataService.getRecordWithParams('/api/OrderDetail/getCourierTracking', searchQuery);
  };
  getPortingDocuments(orderId: number) {
    return this.dataService.getRecord('/api/OrderDetail/getPortingDocuments/' + orderId);
  }

  downloadFile(documentId: number) {
    return this.dataService.getRecord('/api/OrderDetail/downloadPortingFile/' + documentId);
  };

  private isOrderAvailableSubject = new BehaviorSubject<any>(null);
  isOrderAvailable$ = this.isOrderAvailableSubject.asObservable();

  setOrderAvailability(value: any) {
    this.isOrderAvailableSubject.next(value);
  }
  getNotificationCount() {
    return this.dataService.getRecord('/api/OrderDetail/getNotificationCount');
  };

  getManageShoppingListForOrderChange(searchItem: any) {
    return this.dataService.getRecordWithParams('/api/OrderDetail/getManageShoppingListForOrderChange', searchItem);
  };
  getShoppingDocumentFileUploaderInstance() {

    //refer old app
  };

  getShoppingDocumentFileUploaderInstanceForPorting() {

    //refer old app
  };

  sendMailToSalesForSnapScanAndCreditCard(orderId: number) {
    return this.dataService.post('/api/OrderDetail/sendMailToSalesForSnapScanAndCreditCard/' + orderId, this.data);
  };

  saveCreditCardPortingDetails(orderDetail: string) {
    return this.dataService.post('/api/OrderDetail/saveCreditCardPortingDetails', orderDetail);
  };

  saveShoppingDocumentByCheckoutId(orderAndCheckoutId: number) {
    return this.dataService.post('/api/OrderDetail/saveShoppingDocumentByCheckoutId', orderAndCheckoutId);
  };

  getShoppingProductsForConfiguration() {
    return this.dataService.getRecord('/api/productDetail/getShoppingProductsForConfiguration');
  };

  saveShopConfiguration(shopProductList: any) {
    return this.dataService.post('/api/productDetail/saveShopConfiguration', shopProductList);
  };








  saveBillingPromoConfiguration(serviceprovider: any) {
    return this.dataService.post('/api/ServiceProvider/SaveBillingPromoConfiguration', serviceprovider);
  }

  saveJourneyProduct(serviceprovider: any) {
    return this.dataService.post('/api/productDetail/saveJourneyProduct', serviceprovider);
  }

  getJourneyProduct(applicationId: number) {
    return this.dataService.getRecord('/api/productDetail/getJourneyProduct/' + applicationId);
  }
  getJourneyProductStatusTrue(applicationId: number) {
    return this.dataService.getRecord('/api/productDetail/getJourneyProductStatusTrue/' + applicationId);
  }

  updateJourneyProduct(serviceprovider: any) {
    return this.dataService.post('/api/productDetail/updateJourneyProduct', serviceprovider);
  }

  updateApplicationJourneyProduct(serviceprovider: any) {
    return this.dataService.post('/api/productDetail/updateApplicationJourneyProduct', serviceprovider);
  }

  getShoppingOrderAddressPDF(orderLineItemId: number) {
    return this.dataService.getReport('/api/OrderDetail/getShoppingOrderAddressPDF/' + orderLineItemId);
  }

  updateShoppingAddress(customerDetails: any) {
    return this.dataService.post('/api/OrderDetail/updateShoppingAddress', customerDetails);
  }

  getShoppingDashBoardList(searchQuery: string) {
    return this.dataService.getRecordWithParams('/api/OrderDetail/getShoppingDashBoardList', searchQuery);
  };
  cancelOrderLineitem(orderLineItemId: number, isCompletedShoppingProduct: any) {
    return this.dataService.post('/api/OrderDetail/cancelOrderLineitem/?orderLineItemId=' + orderLineItemId + ' &isCompletedShoppingProduct=' + isCompletedShoppingProduct, this.data);
  };
}
